import React from 'react';
import decodeJson from '@seccon/shared/utils/decodeJson';
import { ToastContext } from '@seccon/core/contexts/toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import CSRFContext from '@seccon/core/contexts/csrf';

const useUpdateSelectedFields = (setSelectedPersonnel) => {
  const queryClient = useQueryClient();
  const toastApi = React.useContext(ToastContext);
  const csrfToken = React.useContext(CSRFContext);
  return useMutation({
    mutationFn: ({ sessionId, selectedPersonnel, selectedFields }) => (
      fetch(`/personnelComparisonTool/${ sessionId }/personnelToVerify/verify?mappedId=${ selectedPersonnel.id }`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'anti-csrf-token': csrfToken
        },
        body: JSON.stringify({ updateBasedOnMappedFields: selectedFields })
      }).then(decodeJson)
    ),
    onSuccess: (_data, variables) => {
      const { sessionId, selectedPersonnel } = variables;
      const keySessionId = String(sessionId);
      toastApi.success('Personnel record was updated successfully.');

      queryClient.invalidateQueries({ queryKey: ['personnelOverviewData', keySessionId] });
      queryClient.invalidateQueries({ queryKey: ['personnelToVerify', keySessionId] });
      queryClient.invalidateQueries({
        queryKey: ['personnelToVerifyFields', keySessionId, selectedPersonnel.id]
      });
      setSelectedPersonnel(selectedPersonnel);
    },
    onError: ({ body }) => {
      toastApi.error(body && body?.message ? `Error: ${ body.message }` : 'Unable to update personnel. Please try again');
    }
  });
}

export default useUpdateSelectedFields;
